import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './locales/en';
import ua from './locales/ua';
import ru from './locales/ru';

Vue.use(VueI18n);

const savedLocale = localStorage.getItem('locale') || 'en';

const messages = {
  en,
  ua,
  ru,
};

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'ua',
  messages,
});

export { i18n };
